export default __webpack_public_path__ + "static/shruteeGanguly2-3d513f10bfda5fe6e929d68f32670ab3.jpg";